export const separatedBackground = {
  // TODO: use theme
  backgroundColor: '#ffe082',
};

export const separatedText = {
  // TODO: use theme
  color: '#ed6000',
};
